export const cart = {
  cartDetails: {
    id: 'ID',
    proceedToCheckout: 'Aller à la caisse',
    cartName: "Panier d'achat #{{code}}",
    itemsNotReserved: 'Les articles dans le panier ne seront pas réservés.',
    article: 'article(s)',
  },
  cartItems: {
    id: 'ID',
    description: 'Description',
    item: 'Article',
    itemPrice: 'Article Prix',
    quantity: 'Quantité',
    quantityTitle: "La quantité indique le nombre total d'articles dans votre panier.",
    total: 'Total',
    cartTotal: "Ton panier d'achat ({{count}})",
    cartTotal_plural: "Ton panier d'achat ({{count}})",
    speditionArticle: "Articles d'expédition",
    itemAddedToCart: 'Votre article a été ajouté au panier',
    personalisation: 'Personnalisation',
    personalised: 'personnalisé',
    fontStyle: 'Police de caractères',
    yourInput: 'Tes données',
    removeFromCart: 'Retirer',
    itemCounterMinRestrition: `Le nombre minimum d'articles pour un produit est de 1.`,
    itemCounterMaxRestrition: `Le nombre maximum d'articles pour ce produit est de {{max}}.`,
  },
  orderCost: {
    orderSummary: 'Aperçu des commandes',
    subtotal: 'Sous-total après réductions de prix:',
    shipping: 'Expédition:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'économisé:',
    salesTax: 'TVA:',
    grossTax: 'Le montant total de la commande ne comprend pas le montant de la taxe suivante:',
    grossIncludeTax: "Le montant total de la commande comprend des taxes d'un montant de",
    total: 'Total:',
    toBeDetermined: 'reste à déterminer',
  },
  voucher: {
    coupon: "Tu as un bon d'achat ou un code avantage ?",
    couponGiftcard: "Tu as un bon d'achat ou un code avantage ?",
    coupon_plural: "Bons d'achat ou codes avantages",
    apply: 'Appliquer',
    placeholder: 'Code promotionnel',
    applyVoucherSuccess: '{{voucherCode}} a été déposé.',
    removeVoucherSuccess: '{{voucherCode}} a été supprimé.',
    anchorLabel: 'Saisir ou supprimer un bon/code avantage.',
    vouchersApplied: 'Saisir ou supprimer un bon/code avantage',
    availableCoupons: 'Codes avantage disponibles',
    availableCouponsLabel: 'Tu peux ajouter ces codes avantages.',
    promotionError: {
      ERR01: "L'action est déjà terminée.",
      ERR02: "Le code avantage n'est pas encore valable.",
      ERR03: "Le code avantage n'est pas valable.",
      ERR05: "Ton panier ne contient aucun produit sur lequel l'action peut être appliquée.",
      ERR06: "Le code que tu as indiqué a déjà été utilisé et ne peut pas l'être à nouveau.",
      ERR07: "Le montant minimum de commande pour la promotion n'est pas atteint.",
      ERR08: "Le code avantage n'est pas valable.",
      ERR09:
        'En raison de la logique du meilleur prix, certaines actions ne peuvent pas être utilisées en parallèle.',
    },
  },
  saveForLaterItems: {
    itemTotal: 'Enregistré pour plus tard ({{count}} Article)',
    itemTotal_plural: 'Enregistré pour plus tard({{count}} Article)',
    cartTitle: "Panier d'achat",
    yourCart: 'Votre Panier',
    saveForLater: 'Enregistré pour plus tard',
    moveToCart: 'Ajouter au panier',
    stock: 'Stock',
    forceInStock: 'En stock',
  },
};
